<template>
  <!-- <v-card color="rgba(150, 150, 150, 0.2)"> -->
    <v-container class="text-xs-center">

      <v-layout row wrap justify-center class="pt-5">
        <v-flex xs12 sm6 class="pa-1">
          <h2>Blocking Sequence</h2>
          <iframe width="400" height="711" src="https://www.youtube.com/embed/DRx_K8YgVxk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></v-flex>
      </v-layout>
      <v-layout row wrap justify-center class="pt-5">
        <v-flex xs12 sm6 class="pa-1">
          <h2>Saju-jirugi</h2>
          <iframe width="400" height="711" src="https://www.youtube.com/embed/4mixTVXUca0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <h2>Saju-Makgi</h2>
          <iframe width="400" height="711" src="https://www.youtube.com/embed/C1teOGnd_T0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></v-flex>
      </v-layout>
      <v-layout row wrap justify-center class="pt-5">
        <v-flex xs12 sm6 class="pa-1">
          <h2>Chon-Ji</h2>
          <iframe width="400" height="711" src="https://www.youtube.com/embed/wOG7PRIfK2Y" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <h2>Dan-Gun</h2>
          <iframe width="400" height="711" src="https://www.youtube.com/embed/91gf6XUGSSs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></v-flex>
      </v-layout>
      <v-layout row wrap justify-center class="pt-5">
        <v-flex xs12 sm6 class="pa-1">
          <h2>Do-San</h2>
          <iframe width="400" height="711" src="https://www.youtube.com/embed/Le8CEVabJFU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <h2>Won-hyo</h2>
          <iframe width="400" height="711" src="https://www.youtube.com/embed/2OxtyL8yEbM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></v-flex>
      </v-layout>
      <v-layout row wrap justify-center class="pt-5">
        <v-flex xs12 sm6 class="pa-1">
          <h2>Yul-Gok</h2>
          <iframe width="400" height="711" src="https://www.youtube.com/embed/L2iPdujebvA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <h2>Joong-Gun</h2>
          <iframe width="400" height="711" src="https://www.youtube.com/embed/TjUZZFte6v0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></v-flex>
      </v-layout>

      <v-layout justify-center row wrap class="pt-5">

        <v-flex xs12 sm6 md-4 lg-2>
          <!-- <h3 class="display-3">Follow</h3> -->
          <p class="display-1">
            Add us on social media!
          </p>
          <v-btn
            color="primary"
            icon
            target="_blank"
            href= "https://www.facebook.com/VikingAMA/"
          >
            <v-icon>mdi-facebook</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            icon
            target="_blank"
            href= "https://www.instagram.com/vikingadaptivema"
          >
            <v-icon>mdi-instagram</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            icon
            target="_blank"
            href= "https://www.youtube.com/channel/UCkyk8mb4Z9GsXQEXGYSlESQ"
          >
            <v-icon>mdi-youtube</v-icon>
          </v-btn>

        </v-flex>
      </v-layout>

    </v-container>
  <!-- </v-card> -->
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style scoped>
iframe {
  max-width: 90vw;
}
p {
  margin-top: 16px;
}
h3 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/patterns.vue